const referredNotice = document.querySelector('#referred-notice');
const referredNoticeDismiss = document.querySelector('#referred-notice-dismiss');
const REFERRED_CLASS = 'has-changed-site-notice';

const ReferredNotice = {
	registerEvents: () => {
		referredNoticeDismiss.addEventListener('click', ReferredNotice.dismissNotice);
	},

	dismissNotice: (e) => {
		e.preventDefault();
		referredNotice.remove();
		ReferredNotice.removeTiedClasses();
	},

	removeTiedClasses: () => {
		const elements_with_prefix = document.querySelectorAll(`[class$="${REFERRED_CLASS}"]`);
		elements_with_prefix.forEach((element) => {
			const classes = element.className.split(' ');
			const index = classes.indexOf(REFERRED_CLASS);
			classes.splice(index, 1);
			element.className = classes.join(' ');
		});
	},

	init: () => {
        if ( ! referredNotice ) return;
		ReferredNotice.registerEvents();
	},
};

export default ReferredNotice;
